module.exports = __webpack_public_path__ + "static/media/2Mobile.e9af70b1.png";